
export function DemoFeaturesSection() {
  const features = [
    {
      icon: 'ri-brain-line',
      title: 'UK-Trained AI Engine',
      description: 'Our machine learning models are specifically trained on UK phishing datasets, making them highly effective at detecting local threats.',
      stats: '99.7% Detection Rate'
    },
    {
      icon: 'ri-smartphone-line',
      title: 'Cross-Platform Protection',
      description: 'Seamless protection across mobile and desktop platforms, covering email, SMS, and messaging apps.',
      stats: 'iOS, Android, Windows, Mac'
    },
    {
      icon: 'ri-dashboard-line',
      title: 'Real-Time Dashboard',
      description: 'Get instant visibility into your security posture with actionable insights and employee risk assessments.',
      stats: 'Live Threat Monitoring'
    },
    {
      icon: 'ri-graduation-cap-line',
      title: 'Micro-Learning System',
      description: 'Turn risky moments into learning opportunities with contextual security training delivered in real-time.',
      stats: '85% Behavior Improvement'
    },
    {
      icon: 'ri-cloud-line',
      title: 'Remote Deployment',
      description: 'Deploy and manage across all company devices without needing an internal IT department.',
      stats: '5-Minute Setup'
    },
    {
      icon: 'ri-shield-check-line',
      title: 'Enterprise Integration',
      description: 'Works seamlessly with Microsoft 365, Gmail, WhatsApp Business, and other business tools.',
      stats: '20+ Integrations'
    }
  ];

  return (
    <section className="py-24 bg-gradient-to-b from-black to-gray-900">
      <div className="container mx-auto px-6">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">
              What You'll See in the Demo
            </h2>
            <p className="text-xl text-gray-400">
              Discover the powerful features that make Driscop the perfect cybersecurity solution for UK SMEs
            </p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {features.map((feature, index) => (
              <div key={index} className="bg-gray-800/50 p-8 rounded-xl border border-gray-700 hover:bg-gray-800/70 transition-all">
                <div className="w-12 h-12 bg-blue-500/200/20 rounded-lg flex items-center justify-center mb-6">
                  <i className={`${feature.icon} text-blue-400 text-xl`}></i>
                </div>
                <h3 className="text-xl font-semibold text-white mb-3">
                  {feature.title}
                </h3>
                <p className="text-gray-400 mb-4 leading-relaxed">
                  {feature.description}
                </p>
                <div className="text-sm font-medium text-blue-400 bg-blue-500/200/20 px-3 py-1 rounded-full inline-block border border-blue-500/30">
                  {feature.stats}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
